import React from 'react';

/**
 * Not Found Component
 */
export const NotFound: React.FC = () => {
  return (
    <div className="text-center py-12">
      <h2 className="text-4xl font-bold text-gray-800 mb-4">404</h2>
      <p className="text-gray-600">ページが見つかりません</p>
    </div>
  );
};
